// Every tunable number in the project lives here. Nothing numeric is a
// literal elsewhere. Expect to edit this file more than any other.

export const config = {
  // i18n
  language: 'en',
  languages: ['en', 'sv'],

  // Camera stream request. Ideal only, never exact: iOS picks the nearest mode.
  camera: {
    facingMode: 'environment',
    idealWidth: 1920,
    idealHeight: 1440,
    idealFrameRate: 30,
    suspendGapMs: 1500, // no animation frame for this long = the page was suspended
    resumeReleaseMs: 2000, // release the camera this long before re-acquiring on resume
  },

  // Backdrop (the video layer). rotation: 'auto' | 0 | 90 | -90 degrees.
  // 'auto' rotates when the stream orientation does not match the viewport.
  backdrop: {
    rotation: 'auto',
  },

  // Renderer
  render: {
    maxPixelRatio: 2,
    reducedPixelRatio: 1.5,
    fpsDropThreshold: 55, // rolling fps below this for fpsDropSeconds drops the pixel ratio
    fpsDropSeconds: 5,
  },

  // Visitor UI (Phase 8)
  ui: {
    speciesLabel: true, // HANDOVER open question 3: the name pill after landing. false removes it.
    labelDelayS: 2,
  },

  // Debug overlay
  debug: {
    holdMs: 3000, // press-and-hold duration in the corner to open
    cornerPx: 120, // size of the top-left hot corner
    logLines: 30,
  },

  // Calibration aids and slider steps (Phase 4)
  calibration: {
    cubeSize: 0.10, // metres
    gridSize: 0.30, // metres, square, centred on the origin
    gridCell: 0.01, // metres
    stepCoarse: { position: 0.01, rotation: 1, fov: 1 },
    stepFine: { position: 0.001, rotation: 0.1, fov: 0.1 },
    range: { position: 1.0, rotation: 90, fovMin: 20, fovMax: 120 },
  },

  // Perch points (Phase 5)
  perches: {
    markerSize: 0.01, // metres
    placeHeightDefault: 0.0, // metres, the plane a tap is projected onto
    normalStepCoarse: 5, // degrees
    normalStepFine: 0.5,
  },

  // The butterfly (Phase 6)
  insect: {
    sizeMultiplier: 1.3, // on top of the real wingspan: 1 = life size. Fredrik 2026-09-19: life size reads small on screen
    crossfade: 0.15, // seconds between clips
    wingGlow: 0.3, // emissive from the albedo, stands in for translucency (0 = off)
    clipSpeed: { fly: 1, land: 1, idle: 1, takeoff: 1 },
    idle: {
      speedMin: 0.8, // playback speed re-rolled on every idle loop
      speedMax: 1.2,
      holdEveryMin: 4, // seconds between random holds
      holdEveryMax: 9,
      holdMin: 0.6, // hold length, seconds
      holdMax: 2.0,
      holdMaxOpenness: 12, // degrees of forewing rotation from closed; holds only near closed
    },
    perchFacing: {
      towardCamera: true, // face the viewer (projected on the perch plane) ...
      jitterDeg: 45, // ... plus or minus this much, re-rolled per landing
    },
  },

  // Flight (Phase 7). Fractions are of the camera frustum at the perch depth:
  // x, y in -1..1 are the visible edges; beyond that is off screen.
  flight: {
    startXFrac: 1.3, // start this far outside the side edge
    startYFracMin: -0.2,
    startYFracMax: 0.8,
    waypoints: 2,
    waypointJitterFrac: 0.25,
    waypointRiseFracMin: 0.1, // waypoints sit above the straight line to the perch
    waypointRiseFracMax: 0.5,
    approachOffsetM: 0.05, // last knot sits this far out along the perch normal
    speedMps: 0.25, // cruising speed; duration = length / speed, clamped below
    arriveMinS: 4,
    arriveMaxS: 6,
    wanderAmpM: 0.03, // wander amplitude
    wanderVerticalScale: 0.6,
    wanderFadeFrac: 0.3, // wander fades to zero over this last fraction of the path
    landClipAtRemainingS: null, // seconds before arrival to start the land clip; null = the clip's own length
    flapBase: 1.0, // fly clip speed at rest ...
    flapGain: 3.0, // ... plus this per m/s of vertical speed
    flapMax: 2.2,
    bankGain: 2.5, // roll per m/s of lateral speed
    bankMaxDeg: 35,
    exitS: 3, // takeoff and exit, total
    exitLiftM: 0.08,
    exitXFrac: 1.4,
    exitYFrac: 1.4,
    idleResetS: 60, // perched and untouched this long -> leaves (Phase 10)
  },
};
